import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CONTENT_TYPES, TEXT_SIZES } from '@helpers/constants'
import Text from '@components/Text'
import List from '@components/List'
import Icon from '@components/Icon'

const SubjectAreaList = (props) => {
  const { item, contentType } = props
  const [sortedSubjectAreas, setSortedSubjectAreas] = useState([])

  useEffect(() => {
    const subjectAreaTexts =
    (contentType === CONTENT_TYPES.BOOK
      ? item?.sections?.flatMap((section) => section.subjectAreaTexts)
      : item?.subjectAreaTexts) ?? []
      
    const sortedSubjectAreas = subjectAreaTexts
      .reduce(
        (acc, text) =>
          acc.some((item) => item.id === text.subjectArea.id)
            ? acc
            : [...acc, text.subjectArea],
        []
      )
      .map((subjectArea) => ({
        ...subjectArea,
        items: [
          ...new Set(
            subjectAreaTexts
              .filter((text) => text.subjectArea.id === subjectArea.id)
              .sort((a, b) => a.orderColumn > b.orderColumn ? 1 : -1)
              .map((text) => text.text)
          ),
        ],
      }))
      .sort((a, b) => a.orderColumn > b.orderColumn ? 1 : -1)

    setSortedSubjectAreas(sortedSubjectAreas)
  }, [item, contentType])

  return (
    <div>
      <Text bold>Centralt innehåll</Text>

      {sortedSubjectAreas.length > 0 ? (
        sortedSubjectAreas.map((subjectArea) => {
          const { id, name, items } = subjectArea
          
          return (
            <div key={`subject-area-${id}`}>
              <Text uppercase size={TEXT_SIZES.XXXSMALL}>
                {name}
              </Text>

              <ul className={`pb-4 font-secondary`}>
                {items.map((item, index) => {
                    return (
                      <li key={`subject-area-text-${index}`} className={`flex items-baseline`}>
                        <Icon icon={'Check'} />
                        <span className={`pl-2 pb-2`}>{item}</span>
                      </li>
                    )
                  }
                )}
              </ul>
            </div>
          )
        })
      ) : (
        <Text>
          Inget centralt innehåll kopplat till{' '}
          {contentType === CONTENT_TYPES.BOOK ? 'boken' : 'avsnittet'} än
        </Text>
      )}
    </div>
  )
}

SubjectAreaList.propTypes = {
  item: PropTypes.object,
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPES)),
}

export default SubjectAreaList
